<template>
  <validation-observer ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ titulo }}
        </p>
      </header>
      <div class="modal-card-body">
        <section>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Ubicación Folio"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.ubicacion" type="text" />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Observación"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input
                v-model="model.observacion"
                type="textarea"
                maxlength="256"
              />
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Usuario Asignado"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-select
                v-model="model.usuarioId"
                placeholder="Seleccione una opción..."
              >
                <option
                  v-for="(item, index) in usuarios"
                  :key="`usuario-${index}`"
                  :value="item.id"
                >
                  {{ item.nombre }}
                </option>
              </b-select>
            </b-field>
          </validation-provider>
        </section>
      </div>
      <footer class="modal-card-foot">
        <div class="buttons">
          <b-button type="is-info" @click="passes(submit)">
            <span>Guardar</span>
          </b-button>
          <button class="button" @click="cerrarForm">
            <span>Salir</span>
          </button>
        </div>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { mapGetters } from 'vuex'

import { bodegaService } from '@/services'

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

export default {
  name: 'FolioForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    titulo: {
      type: String,
      default: 'Agregar Folio'
    },
    recuento: {
      type: Number,
      default: 0
    },
    objeto: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data: () => ({
    model: {},
    usuarios: [],
    cargando: false
  }),
  computed: {
    ...mapGetters('sesion', ['bodega']),
    postModel() {
      return Object.assign(this.model, { recuentoId: this.recuento })
    }
  },
  async created() {
    await this.getUsuarios()
    this.model = this.modeloInicial()
  },
  mounted() {
    this.model = Object.assign(this.model, this.objeto)
  },
  methods: {
    submit() {
      this.$emit('submit', this.postModel)
    },
    cerrarForm() {
      this.$emit('close', false)
    },
    resetForm() {
      this.model = this.modeloInicial()
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    getUsuarios() {
      const self = this
      return bodegaService
        .getUsuariosByBodega(this.bodega.id)
        .then((response) => (self.usuarios = response.data))
        .catch((error) => this.procesarError(error))
    },
    modeloInicial() {
      return {
        ubicacion: null,
        observacion: null,
        usuarioId: null
      }
    }
  }
}
</script>
